import { lazy, Suspense } from 'react'
import { Outlet } from 'react-router'

import LoginModal from '@/components/LoginModal'
import Sidebar from '@/components/Sidebar'
import useTutorCallDesktop from '@/hooks/useTutorCallDesktop'
import { useUserStore } from '@/store'

const TutorCallLayer = lazy(() => import('@/layouts/TutorCallLayer'))

export default function ChatPage() {
  const user = useUserStore((s) => s.user)
  const tutorDesktop = useTutorCallDesktop()
  return (
    <div className="flex h-full w-full bg-white text-sm text-gray-800 font-sans overflow-hidden relative flex">
      <Sidebar />

      <Outlet />

      <LoginModal />
      {tutorDesktop && (
        <Suspense fallback={null}>
          <TutorCallLayer key={user ? String(user.id) : 'guest'} />
        </Suspense>
      )}
    </div>
  )
}
